import React, { useState, useEffect } from 'react';
import './olx_buy.scss';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import APP_BASE_URL from "../../components/Api/globalApi";

const PointsMarketplace = () => {


  const location = useLocation();
  const income = location.state?.data; // Access the passed data safely
  const [products, setProducts] = useState([]);

  const [wallets, setWallets] = useState({});

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  const [sellPoints, setSellPoints] = useState('');
  const [sellPrice, setSellPrice] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);




  useEffect(() => {

    const fetchProducts = async () => {
      try {
        const apResponse = await axios.get(
          `${APP_BASE_URL}/myincome`,
          {
            headers: {
              user_id: localStorage.getItem("user_id"),
            },
          }
        );

        if (apResponse.data.result) {
          setWallets(apResponse.data.data);
        }

  const response = await axios.get(`${APP_BASE_URL}/buylist`, {}, {
          headers: {}
        });

        if (response.data.result) {
          const mappedProducts = response.data.data?.map((item, index) => ({
            id: item.ao_id,
            SellerId: item.ao_u_id,
            points: item.ao_ap,
            price: item.ao_price,
            seller: item.u_referal_id,
          }));
          setProducts(mappedProducts);
        }
      } catch (error) {
        console.error("Error fetching product list:", error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (showPurchaseModal || showSellModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [showPurchaseModal, showSellModal]);

  const handleBuy = (product) => {
    setSelectedProduct(product);
    setShowPurchaseModal(true);
  };

  const confirmPurchase = async () => {
    setShowPurchaseModal(false);
    let calculatedBal = selectedProduct?.points - ((selectedProduct?.points / 1200) * 200)
    if (wallets.u_my_wallet >= selectedProduct.price) {
  const response = await axios.post(`${APP_BASE_URL}/buy`, {
        ao_id: selectedProduct.id,
        ap_point: calculatedBal,
        repurchase: selectedProduct.price,
        sellerId: selectedProduct.SellerId
      }, {
        headers: {
          user_id: localStorage.getItem("user_id")
        }
      });
      
      if (response.data.result) {
        alert(`Purchased ${calculatedBal} AP for $${selectedProduct.price.toFixed(2)}`);
        window.location.reload()
      }
    } else {
      alert('Insufficient funds in My Wallet');
    }
  };

  // const handleSell = () => {
  //   const points = parseInt(sellPoints);
  //   const price = parseFloat(sellPrice);

  //   if (!points || !price) {
  //     alert('Please enter valid values');
  //     return;
  //   }

  //   if (points > wallets.activityPoints) {
  //     alert(`You only have ${wallets.activityPoints} AP available`);
  //     return;
  //   }




  //   setSellPoints('');
  //   setSellPrice('');
  //   setShowSellModal(false);
  // };

  const closeModal = () => {
    setShowPurchaseModal(false);
    setShowSellModal(false);
  };

  return (
    <div className="marketplace-container">
      {/* Mobile Header */}
      {isMobile && (
        <div className="mobile-header">
          {/* <h2>AP Marketplace</h2> */}
          <div className="mobile-wallets">
            <span>Activity Point(AP) - {wallets.u_activity_point}</span>
             <span>Today's Point Rate (1200AP) - RS.{wallets.today_point}
             </span>
            <span>My Wallet  - RS.{wallets.u_my_wallet}</span>
          </div>
        </div>
      )}

      {/* Desktop Wallet Info */}
      {!isMobile && (
        <div className="wallet-info">
          <h2>Your Wallets</h2>
          <div className="wallet-cards">
            <div className="wallet-card">
              <span>Activity Points</span>
              <strong>Activity Point - {wallets.u_activity_point}</strong>
            </div>
             <div className="wallet-card">
              <span>Today's Point Rate</span>
              <strong>Todays Point Rate (1200AP)  - RS.{wallets.today_point}</strong>
            </div>
            <div className="wallet-card">
              <span>My Wallet</span>
              <strong>${wallets.u_my_wallet}</strong>
            </div>
          </div>
        </div>
      )}


      <div className={`products-grid ${isMobile ? 'mobile-view' : ''}`}>
        {products.map((product) => (
          <div key={product.id} className="product-card">
            <div className="product-info">
              <h3>{product.points} AP</h3>
              <p className="price">${product.price}</p>
              <p className="seller">Seller: {product.seller}</p>
            </div>
            <button
              className="buy-now"
              onClick={() => handleBuy(product)}
            >
              {isMobile ? 'Buy' : 'Buy with My Wallet'}
            </button>
          </div>
        ))}
      </div>

      {/* Modals */}
      {showPurchaseModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3>Confirm Purchase</h3>
            <div className="modal-body">
              <p>Buy {selectedProduct?.points} AP for ${selectedProduct?.price.toFixed(2)}</p>
              <div className="balance-change">
                <p>Repurchase Wallet will decrease by ${selectedProduct?.price.toFixed(2)}</p>
                <p>You'll receive {selectedProduct?.points - ((selectedProduct?.points / 1200) * 200)} AP</p>
              </div>
            </div>
            <div className="modal-actions">
              <button className="cancel-btn" onClick={closeModal}>Cancel</button>
              <button className="confirm-btn" onClick={confirmPurchase}>Confirm</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PointsMarketplace;